import { ksaAxios } from '../../../http-common';

export interface ILeadData {
  lead_data: {
    form_type: string | null;
    lead_type: string | null;
    phone_number: string | null;
    name: string | null;
    email: string | null;
    company_name: string | null;
    lead_source_url: string | null;
    ISD: string | null;
  };
  lead_platforms: {
    salesforce: boolean;
    pardot: boolean;
  };
  extra_payload: {
    domain_name: string;
    origin_country: string;
  };
}

class ClearLeadFormCall {
  sendClearLeadData(formData: ILeadData, token: string | null) {
    return ksaAxios.post(
      '/f/common-lead/lead/?captcha_token=' + token,
      formData
    );
  }
}

export default new ClearLeadFormCall();
